module.exports = __webpack_public_path__ + "img/hero_left_artwork.3be913a6.png";